import * as React from 'react';
import { observer } from 'mobx-react';
import { ITranslationsCollection, translate } from 'elc-service';
import { Accordion, LabelSlide } from 'elc-accordion';
import { Body2, Heading5, Body1 } from 'elc-typography';
import { ContentSpacing } from 'elc-base-theme';
import styled from 'styled-components';
import { Row } from 'elc-grid';
import { classes } from '../../utils/Classes';

export interface IProductIngredientsProps {
    translations?: ITranslationsCollection;
    useAccordion?: boolean;
    allIngredients: string;
}

const StyledAccordion = styled(Accordion)`
    margin-bottom: ${ContentSpacing.space16};
`;

const StyledAdditionalContent = styled(Body2)`
    padding-top: ${ContentSpacing.space20};
`;

const StyledRow = styled(Row)`
    display: flex;
    flex-direction: column;
    margin-bottom: ${ContentSpacing.space16};
`;

const StyledHeading = styled(Heading5)`
    margin-bottom: ${ContentSpacing.space8};
`;

export const ProductIngredients = translate([
    'productIngredientsAccordionLabel',
    'ingredientsDisclaimerMessage'
])(
    observer((props: IProductIngredientsProps) => {
        const { useAccordion, allIngredients } = props;
        const {
            productIngredientsAccordionLabel,
            ingredientsDisclaimerMessage
        } = props.translations as ITranslationsCollection;

        const productIngredientsClassNames = classes('product-ingredients');
        const productOverviewAccordionClassNames = classes('product-full-accordion');
        const productOverviewAccordionAdditionalContentClassNames = classes(
            '-product-full-overview-accordion-specific-content'
        );

        return (
            <div className={productIngredientsClassNames}>
                {useAccordion ? (
                    <StyledAccordion className={productOverviewAccordionClassNames}>
                        <LabelSlide
                            id={productIngredientsAccordionLabel}
                            title={productIngredientsAccordionLabel}
                        >
                            <Body2 dangerouslySetInnerHTML={{ __html: allIngredients }} />
                            {ingredientsDisclaimerMessage && (
                                <StyledAdditionalContent
                                    className={productOverviewAccordionAdditionalContentClassNames}
                                >
                                    {ingredientsDisclaimerMessage}
                                </StyledAdditionalContent>
                            )}
                        </LabelSlide>
                    </StyledAccordion>
                ) : (
                    <StyledRow className={productIngredientsClassNames}>
                        <StyledHeading>{productIngredientsAccordionLabel}</StyledHeading>
                        <Body1 dangerouslySetInnerHTML={{ __html: allIngredients }} />
                    </StyledRow>
                )}
            </div>
        );
    })
);
